import type { AxiosResponse } from "axios";

export interface IApiClientResponse<Data> extends AxiosResponse<Data> {
  data: Data;
  status: number;
  statusText: string;
  headers: AxiosResponse["headers"];
  request?: Request;
}

export class AxiosApiClientResponse<Data> implements IApiClientResponse<Data> {
  public data: Data;
  public status: number;
  public statusText: string;
  public headers: AxiosResponse["headers"];
  public request?: Request;
  public config: AxiosResponse["config"];

  constructor(private _response: AxiosResponse<Data>) {
    this.data = this._response.data;
    this.status = this._response.status;
    this.statusText = this._response.statusText;
    this.headers = this._response.headers;
    this.request = this._response?.request;
    this.config = this._response.config;
  }
}
